
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { formatDateTime, formatDateTimeForInput, parseDateTimeFromInput } from '../../../util';

@Component
export default class RtPath extends Vue {
  @Prop({ required: true })
  readonly dateFrom!: Date;
  @Prop({ required: true })
  readonly dateTo!: Date;
  @Prop({ required: true })
  readonly dateCurrent!: Date;

  readonly maxRangeMilliseconds = 7 * 24 * 60 * 60 * 1000; //magic value: max date range is 1 week

  formatDateTime = formatDateTime;

  get dateFromForInput(): string {
    return formatDateTimeForInput(this.dateFrom);
  }

  set dateFromForInput(val: string) {
    if (!val) {
      this.$emit('update:dateFrom', new Date(this.dateFrom));
      return;
    }

    const date = parseDateTimeFromInput(val);
    this.$emit('update:dateFrom', date);
    if (date.getTime() > this.dateCurrent.getTime()) { // keep dateCurrent in between
      this.$emit('update:dateCurrent', date);
    }
    if (date.getTime() > this.dateTo.getTime()) { //keep dateFrom <= dateTo 
      this.$emit('update:dateTo', date);
    }
    if (date.getTime() + this.maxRangeMilliseconds < this.dateTo.getTime()) { //keep range in bounds
      this.$emit('update:dateTo', new Date(date.getTime() + this.maxRangeMilliseconds));
    }
  }

  get dateToForInput(): string {
    return formatDateTimeForInput(this.dateTo);
  }

  set dateToForInput(val: string) {
    const date = parseDateTimeFromInput(val);
    this.$emit('update:dateTo', date);
    if (date.getTime() < this.dateCurrent.getTime()) { // keep dateCurrent in between
      this.$emit('update:dateCurrent', date);
    }
    if (date.getTime() < this.dateFrom.getTime()) { //keep dateFrom <= dateTo 
      this.$emit('update:dateFrom', date);
    }
    if (this.dateFrom.getTime() + this.maxRangeMilliseconds < date.getTime()) { //keep range in bounds
      this.$emit('update:dateFrom', new Date(date.getTime() - this.maxRangeMilliseconds));
    }
  }

  get rangeSeconds(): number {
    return (this.dateTo.getTime() - this.dateFrom.getTime()) / 1000;
  }

  get secondsCurrent(): number {
    return (this.dateCurrent.getTime() - this.dateFrom.getTime()) / 1000;
  }

  set secondsCurrent(val: number) {
    const date = new Date(this.dateFrom.getTime() + val * 1000);
    this.$emit('update:dateCurrent', date);
  }

  get uid(): string {
    return this._uid;
  }
}
